import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import auth from '@udacity/ureact-hoth';
import { Spinner } from '@chakra-ui/react';

import { useFetchMeQuery } from 'app/apis/reviews';
import { isReviewsAccessDenied } from 'app/apis/helpers/reviews-helpers';
import { fetchUser, getCurrentUser } from 'app/common/domains/user/user-actions';
import { DashboardSwitcher } from 'app/common/views/dashboard-switcher';
import { getIsUserLoading, getPreferredLanguage } from 'app/common/domains/user/user-selectors';

import styles from './app-container.module.scss';
import { useAppDispatch } from './store';
import i18n from './i18n';

export const AppContainer: React.FC = ({ children }) => {
  const isUserLoading = useSelector((state) => getIsUserLoading(state));
  const preferredLanguage = useSelector((state) => getPreferredLanguage(state));
  const { data: reviewsMe } = useFetchMeQuery();
  const isAccessDenied = isReviewsAccessDenied(reviewsMe);

  const dispatch = useAppDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(getCurrentUser(auth.getCurrentUser()));
    dispatch(fetchUser());
  }, []);

  useEffect(() => {
    if (preferredLanguage) {
      i18n.changeLanguage(preferredLanguage);
    }
  }, [preferredLanguage]);

  useEffect(() => {
    if (isAccessDenied) {
      history.push('/prompt?error=true');
    }
  }, [isAccessDenied]);

  return (
    <div className={styles['app-container']}>
      {!isUserLoading ? (
        children || <DashboardSwitcher />
      ) : (
        <div className={styles['loading-container']}>
          <div className={styles['loading']}>
            <Spinner />
          </div>
        </div>
      )}
    </div>
  );
};
